import { render, staticRenderFns } from "./FightersPromo.vue?vue&type=template&id=b396d2dc&lang=pug&"
import script from "./FightersPromo.vue?vue&type=script&lang=js&"
export * from "./FightersPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports